var pym = require("./lib/pym");
require("./lib/webfonts");

var pymChild;
var renderLineChart = require("./renderLineChart");

//Initialize graphic
var onWindowLoaded = function() {
  var series = formatData(window.DATA);
  render(series);

  window.addEventListener("resize", () => render(series));

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

//Format graphic data for processing by D3.
var formatData = function(data) {

  const groups = [...new Set(data.map(item => item.Group))];
  var series = [];

  for (var item in groups) {
    var group = groups[item];
    groupData = data.filter(d => d.Group == group);
    var subseries = [];
    for (var column in data[0]) {
      if (column == "date" | column == "Group") continue;
      subseries.push({
        name: column,
        values: groupData.map(d => ({
          date: d.date,
          amt: d[column]
        }))
      });
    }
    series.push({
      group: group,
      values: subseries
    });
  }

  return series;
};

// Render the graphic(s). Called by pym with the container width.
var render = function(data) {
  // Render the chart!
  var container = "#line-chart";
  var element = document.querySelector(container);
  var width = element.offsetWidth;
  renderLineChart({
    container,
    width,
    data,
    dateColumn: "date",
    valueColumn: "amt"
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

//Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
